/*!
 * frontend
 * name:  /  innogy-web,
 * buildDate: Wed Jul 11 2018 14:29:13 GMT+0200 (CEST),
 * packageVersion: 2.24.0
 */
webpackJsonp([15],{

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(80);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = __webpack_require__(116);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(102);

var _keys2 = _interopRequireDefault(_keys);

var _AbstractController2 = __webpack_require__(37);

var _AbstractController3 = _interopRequireDefault(_AbstractController2);

var _fasterdom = __webpack_require__(22);

var _fasterdom2 = _interopRequireDefault(_fasterdom);

var _jquery = __webpack_require__(16);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//require('ie9-oninput-polyfill')

/**
 * Default RegExp definitions
 * info: hasUserName will be set on init, cause actual username isn't available yet
 */
var regex = {
	hasNumber: /\d/,
	hasUpperLower: /^(?=.*([a-z]))(?=.*([A-Z])).+$/,
	hasSpecialChar: /^(?=.*([_!@%#.,:;"'&*()+\-?$\/\\])).+$/,
	hasMinLength: /^.{8,}$/,
	hasUserName: ''
};

/**
 * Validation level mapping
 * - levels must ascend in strength ( e.g. 0 = invalid, ... last_N = strongest )
 */
var validationLevelTypes = [// eslint-disable-line one-var
'invalid', 'medium', 'strong'];

/**
 * Update password meter component
 * - set/unset validation errors
 * - set validation level bar
 * - show/hide error messages
 * @return {void}
 */
function updateDOM() {
	var _this = this;

	_fasterdom2.default.mutateInstant(function () {
		var cls = 'strength-bar--' + validationLevelTypes.join(' strength-bar--');

		// update level bar
		_this.$levelBar.removeClass(cls).addClass('strength-bar--' + _this.getValidationLevel());

		_this.$strengthLabel.text(_this.getValidationLevel());

		// update list items
		_this.$invalid.filter('.valid').removeClass('valid').filter('[required]').addClass('invalid');

		_this.$valid.removeClass('invalid').addClass('valid');

		// remove error class if password is set
		if (!!_this.pw) {
			_this.$wrapperPW.removeClass('error');
		}

		// update password meter component
		_this.$scope.removeClass('password-meter--invalid');

		if (!_this.isValid && _this.error) {
			_this.$scope.addClass('password-meter--invalid');
		}

		// update password comfirm error
		_this.$wrapperPWConfirm.removeClass('error');

		if (!!_this.pwConfirm && !_this.isConfirmed && _this.isValid && !_this.error) {
			_this.$wrapperPWConfirm.addClass('error');
		}
	});
}

/**
 * Validate entered password
 * - check validation strength
 * - update validation level
 * - update valid and invalid collection
 * @param {boolean} force - validate even password is empty string
 * @return {void}
 */
function validatePW(force) {
	var _this2 = this;

	this.error = false;
	this.$valid = (0, _jquery2.default)([]);
	this.$invalid = (0, _jquery2.default)([]);
	this.level = validationLevelTypes.length - 1;

	var _loop = function _loop(i) {

		(0, _keys2.default)(_this2.conditions[i]).forEach(function (key) {
			var val = _this2.conditions[i][key],
			    regx = _this2.regex[key];

			val.forEach(function (el) {
				var $el = (0, _jquery2.default)(el);

				if ((force || _this2.pw) && !!regx && regx.exec(_this2.pw) !== null) {
					_this2.$valid = _this2.$valid.add($el);
				} else {
					_this2.level = i - 1;
					_this2.$invalid = _this2.$invalid.add($el);

					if (force) {
						$el.addClass('valid');
					}

					if ($el.is('.valid[required]') || $el.is('.invalid[required]')) {
						_this2.error = true;
					}
				}
			});
		});
	};

	for (var i = this.level; i > 0; i--) {
		_loop(i);
	}
}

/**
 * Handles password input blur events
 * - updates password and password confirm values
 * - updates dom
 * @return {void}
 */
function handleBlur() {
	var _this3 = this;

	_fasterdom2.default.measureInstant(function () {
		_this3.pw = _this3.$inputPW.val();
		_this3.pwConfirm = _this3.$inputPWConfirm.val();
		_this3.isConfirmed = !!_this3.pw && !!_this3.pwConfirm && _this3.pw === _this3.pwConfirm;
	});

	updateDOM.call(this);
}

/**
 * Handles password input change events
 * - updates password and runs it's validation
 * - updates dom
 * @param {boolean} force - validate even password is empty string
 * @return {void}
 */
function handleInput(force) {
	var _this4 = this;

	_fasterdom2.default.measureInstant(function () {
		_this4.pw = _this4.$inputPW.val();

		validatePW.call(_this4, force);
	});

	updateDOM.call(this);
}

/**
 * Adds event listeners on password input elements
 * @return {void}
 */
function addHandler() {
	this.$inputPW.on('input', handleInput.bind(this, false));
	this.$inputPW.on('change', handleBlur.bind(this));

	this.$inputPWConfirm.on('blur', handleInput.bind(this, true));
	this.$inputPWConfirm.on('change', handleBlur.bind(this));
}

/**
 * Sets up validation conditions from list items data attributes
 * - creates array with conditions based on validation leves
 * @return {void}
 */
function setupConditions() {
	var _this5 = this;

	_fasterdom2.default.measureInstant(function () {
		_this5.conditions = validationLevelTypes.map(function (type) {
			var obj = {};

			_this5.$scope.find('.password-meter--' + type + ' li[data-validate]').each(function (i, el) {
				var $el = (0, _jquery2.default)(el),
				    regx = $el.attr('data-validate');

				if (!obj.hasOwnProperty(regx)) {
					obj[regx] = [];
				}

				obj[regx].push($el);
			});

			return obj;
		});
	});
}

/**
 * Setup regular expressions for validation
 * @return {void}
 */
function setupRegex() {
	var _this6 = this;

	_fasterdom2.default.measureInstant(function () {
		var username = _this6.$inputUser ? _this6.$inputUser.val() : '';

		_this6.regex = (0, _assign2.default)({}, regex);
		_this6.regex.hasUserName = new RegExp('^(?!=($))(?!.*' + username + ').+$', 'i');
	});
}

/**
 * Class representing a password meter instance.
 * Controls the state of the password meter conditions.
 * Controls password meter behavior.
 * @extends { AbstractController }
 */

var PasswordMeterController = function (_AbstractController) {
	(0, _inherits3.default)(PasswordMeterController, _AbstractController);

	function PasswordMeterController() {
		(0, _classCallCheck3.default)(this, PasswordMeterController);

		var _this7 = (0, _possibleConstructorReturn3.default)(this, _AbstractController.call(this));

		_this7.$scope = null;
		return _this7;
	}

	/**
  * Initialises the controller.
  * Has to be called after ready event.
  *
  * @param { object } $root - jQuery wrapped DOM node
  * @returns { void }
  * @public
  */


	PasswordMeterController.prototype.init = function init($root) {

		this.$scope = $root;
		this.$levelBar = $root.find('.strength-bar');
		this.$strengthLabel = this.$levelBar.find('.strength-bar__label');
		this.$inputUser = $root.find('input[type="hidden"]').eq(0);
		this.$inputPW = $root.find('input[type="password"]').eq(0);
		this.$inputPWConfirm = $root.find('input[type="password"]').eq(1);
		this.$wrapperPW = this.$inputPW.closest('.field-group');
		this.$wrapperPWConfirm = this.$inputPWConfirm.closest('.field-group');
		this.pw = null;
		this.pwConfirm = null;

		// available validation levels (see validationLevelTypes): {index} => {type name};
		this.level = 0;
		this.conditions = [];
		this.$valid = [];
		this.$invalid = [];
		this.isConfirmed = false;

		setupConditions.call(this);
		setupRegex.call(this);
		addHandler.call(this);
	};

	/**
  * Get type name of current validation level
  * @return {string} - type name
  */
	PasswordMeterController.prototype.getValidationLevel = function getValidationLevel() {
		return validationLevelTypes[this.level];
	};

	(0, _createClass3.default)(PasswordMeterController, [{
		key: 'isValid',
		get: function get() {
			return this.level > 0;
		}
	}]);
	return PasswordMeterController;
}(_AbstractController3.default);

/**
 * @public
 * @return {PasswordMeterController} PasswordMeterController class
 */


exports.default = PasswordMeterController;

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Basic module class definition providing basic interface functions
 */
var BaseModule = function () {

	/**
  * Initialize a module with a config provided by the AppConmoduleConfig
  * @param {moduleConfig} moduleConfig - Config parsed from teh DOM
  */
	function BaseModule(moduleConfig) {
		(0, _classCallCheck3.default)(this, BaseModule);


		/**
   *
   * @type {Object}
   */
		this.node = moduleConfig.node;
		/**
   *
   * @type {Object}
   */
		this.config = moduleConfig.config;
		/**
   *
   * @type {string}
   */
		this.identifier = moduleConfig.identifier;
	}

	BaseModule.prototype.init = function init() {
		return this;
	};

	/**
  * @return {string} returns the identifier for the module instance
  */


	BaseModule.prototype.getIdentifier = function getIdentifier() {
		return this.identifier;
	};

	return BaseModule;
}();

exports.default = BaseModule;

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Base = __webpack_require__(579);

var _Base2 = _interopRequireDefault(_Base);

var _PasswordMeter = __webpack_require__(1422);

var _PasswordMeter2 = _interopRequireDefault(_PasswordMeter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @extends {BaseModule}
 */
var PasswordMeterModule = function (_BaseModule) {
	(0, _inherits3.default)(PasswordMeterModule, _BaseModule);

	function PasswordMeterModule(config) {
		(0, _classCallCheck3.default)(this, PasswordMeterModule);
		return (0, _possibleConstructorReturn3.default)(this, _BaseModule.call(this, config));
	}

	PasswordMeterModule.prototype.init = function init() {
		_BaseModule.prototype.init.call(this);

		var controllerInstance = new _PasswordMeter2.default();

		this.passwordMeter = controllerInstance.init(this.node);
	};

	return PasswordMeterModule;
}(_Base2.default);

exports.default = PasswordMeterModule;

/***/ })

});


// WEBPACK FOOTER //
// PasswordMeterModule.chunk.js